import React from "react";

class ValueCard extends React.Component {
  state = {
    selected: false,
    visible: true,
  };
  cardSelect = () => {
    if (this.props.numCardsSelected < this.props.maxSelectable) {
      this.setState({
        selected: !this.state.selected,
      });
      this.state.selected
        ? this.props.deselectionHandler(this.props.name)
        : this.props.selectionHandler(this.props.name);
    } else {
      if (this.state.selected) {
        this.setState({
          selected: !this.state.selected,
        });
        this.props.deselectionHandler(this.props.name);
      } else {
        this.props.maxSelectionHandler(this.props.name);
      }
    }
  };

  filteroutCard() {
    if (!this.state.selected) {
      this.setState({
        visible: false,
      });
    } else {
      this.setState({
        selected: false,
      });
    }
  }

  deselectAlreadyDeselectedCards = (cards) => {
    if (cards.indexOf(this.props.name) == -1) {
      this.setState({
        visible: false,
      });
    }
  };

  render() {
    let cardStyle = this.state.selected
      ? {
          backgroundColor: "#24ffff",
          border: "2.5px solid black",
        }
      : {};

    return (
      <div>
        {this.state.visible ? (
          <div
            className="card border-light text-dark border-dark value-card"
            onClick={this.cardSelect}
            style={cardStyle}
          >
            <div className="card-header text-center text-uppercase font-weight-bold">
              {this.props.name}
            </div>
            <div className="card-body">
              <p className="card-text text-left">{this.props.description}</p>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default ValueCard;
